/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rating_Local_NoteInputs */

const en_directory_detail_rating_local_note = /** @type {(inputs: Directory_Detail_Rating_Local_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratings are stored in this browser session until accounts launch.`)
};

const zh_directory_detail_rating_local_note = /** @type {(inputs: Directory_Detail_Rating_Local_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号体系上线前，评分仅保存在当前浏览器会话中。`)
};

/**
* | output |
* | --- |
* | "Ratings are stored in this browser session until accounts launch." |
*
* @param {Directory_Detail_Rating_Local_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rating_local_note = /** @type {((inputs?: Directory_Detail_Rating_Local_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rating_Local_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rating_local_note(inputs)
	return zh_directory_detail_rating_local_note(inputs)
});
export { directory_detail_rating_local_note as "directory.detail.rating_local_note" }